/*
 * @Author: xiaoyuling
 * @Date: 2024-04-03 16:23:21
 * @LastEditTime: 2024-05-17 18:17:27
 * @LastEditors: xiaoyuling
 * @Description: edit
 * @FilePath: /IOT4CMS/src/components/TopBars/index.js
 */
import React from 'react'
import { Radio, DatePicker, Button } from 'antd'
import moment from 'moment'
import styles from './index.less'

import { DownloadOutlined, ReloadOutlined } from '@ant-design/icons'
import { dateSelectorType } from '@/models/global'

const { RangePicker } = DatePicker

export default function TopBars(props) {
	const {
		fixedDate,
		dateType, //='moment'
		dateValue,
		onRadioChange = () => {},
		onRangePickerChange = () => {},
		downLoadFile = () => {},
		onRefresh = () => {},
	} = props

	return (
		<div className={styles.topBarsWrap}>
			<div className={styles.rightPart}>
				<Radio.Group
					value={fixedDate}
					size="small"
					buttonStyle="solid"
					onChange={onRadioChange}
				>
					<Radio.Button value={dateSelectorType.today}>今天</Radio.Button>
					<Radio.Button value={dateSelectorType.yesterday}>昨天</Radio.Button>
					<Radio.Button value={dateSelectorType.sevenDays}>近7天</Radio.Button>
					<Radio.Button value={dateSelectorType.thirtyDays}>
						近30天
					</Radio.Button>
				</Radio.Group>

				<RangePicker
					// value={dateValue}
					value={
						dateType == ''
							? [
									moment(dateValue[0], 'YYYY-MM-DD'),
									moment(dateValue[1], 'YYYY-MM-DD'),
							  ]
							: dateValue
					}
					allowClear={false}
					// onCalendarChange={(val) => setDates(val)}
					onChange={onRangePickerChange}
					// onOpenChange={onOpenChange}
				/>
			</div>
			<div>
				<Button
					className={styles.downloadBtn}
					type="primary"
					ghost
					style={{ marginRight: '21px' }}
					onClick={downLoadFile}
					icon={<DownloadOutlined />}
				>
					数据下载
				</Button>
				<Button
					className={styles.downloadBtn}
					style={{ marginRight: '28px' }}
					type="primary"
					ghost
					onClick={onRefresh}
					icon={<ReloadOutlined />}
				>
					刷新
				</Button>
			</div>
		</div>
	)
}
